export const APP_CONSTANTS = {
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 15,
    PAGE_SIZE_OPTIONS: [15, 30, 45],
  },
  DATE_FORMATS: {
    DISPLAY_DATE: 'dd/MM/yyyy',
    API_DATE: 'yyyy-MM-dd',
  },
  TOAST: {
    SUCCESS: 'Operation completed successfully!',
    ERROR: 'Something went wrong!',
  },
};

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'MMM DD YYYY', // Parsing format
  },
  display: {
    dateInput: 'MMM DD YYYY', // Input display format
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MMM DD YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
